import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about-us/AboutUsClient.tsx");
